import HTTP, { requestCanceller } from '@/utils/http';
import pageableFactory from '@/store/modules/mixins/pageable';
import crudableFactory from '@/store/modules/mixins/crudable';

const pageable = pageableFactory();
const crudable = crudableFactory();
const defaultState = () => ({
  ...pageable.state,
  ...crudable.state,
  pagingLimit: 25,
  contact: null,
});

const contactsModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    ...crudable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { updated }) {
      state.contact = updated;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET: crudable.actions.getPartialApplication({
      uriRoot: 'contacts',
      name: 'contact',
      props: ['title', 'email'],
    }),
    CREATE: crudable.actions.createPartialApplication({
      uriRoot: 'contacts',
      name: 'contact',
      suppressFormErrors: true,
    }),
    UPDATE: crudable.actions.updatePartialApplication({
      uriRoot: 'contacts',
      name: 'contact',
      props: ['title', 'email'],
      isSingular: false,
      suppressFormErrors: true,
    }),
    DELETE: crudable.actions.deletePartialApplication({ uriRoot: 'contacts', name: 'contact' }),
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'contacts',
    }),
    // TODO this isn't using the store at all.
    async SEARCH_RESULTS(_, { search, limit = 50 }) {
      // cancel the in flight request
      requestCanceller.cancelCurrentRequest('wait');

      // make the request
      try {
        const response = await HTTP({
          url: 'contacts',
          params: {
            query: search,
            limit,
          },
        });

        return response.data.data;
      } catch (error) {
        // we cancelled the request so return empty list
        if (error.message === 'cancelled') {
          return [];
        }

        // still searching
        if (error.message === 'wait') {
          return null;
        }

        // re-throw unespected errors
        throw error;
      }
    },
    CANCEL_SEARCH() {
      requestCanceller.cancelCurrentRequest('cancelled');
    },
  },
  getters: {
    ...pageable.getters,
    contact: state => state.contact,
  },
};

export default contactsModule;
